// extracted by mini-css-extract-plugin
module.exports = {"tidyList":"IconsList_tidyList__o3Qas","middleApp":"IconsList_middleApp__m2hT_","placeholderApp":"IconsList_placeholderApp__Pgg93"};